// extracted by mini-css-extract-plugin
export var editButton = "_qi-0";